import { styled } from "styled-components";

export const PersonalInfoDiv = styled.div`
  width: 100%;
  height: 200px;

  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  padding: 8px;
  margin-bottom: 150px;
`;
